var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-error"},[_c('div',{staticClass:"text"},[_c('p',[_vm._v("The search failed, details are:")]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.message)}}),_c('p',[_vm._v(" Check our "),_c('SearchHelpLink',{attrs:{"format":"within-alert"}}),_vm._v(" for more tips. ")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }